import { useTranslation } from "react-i18next";

import { useAuth } from "@/shared/stores/useAuth";
import OwnedDeckCardList from "@/cards/common/component/deck-library/OwnedDeckCardList";
import { useDeckCardTalentExpandShare } from "@/cards/common/component/deck-library/useDeckCardTalentExpandShare";
import {
  SEASON_CARD_NAVIGATION,
  getSeasonCardIdFromCard,
  mapSeasonMainCardResponseToPublishedCard,
} from "@/cards/common/utils/app-deck/ownedDeckCardList.utils";

const SeasonCardUserPage = () => {
  const { t } = useTranslation();
  const { userInfo } = useAuth();
  const { onExpandShare, shareModal } = useDeckCardTalentExpandShare({
    cardKind: "season",
  });

  return (
    <>
      <OwnedDeckCardList
        deckCardType="Season_Card"
        viewMode="user"
        purchaseFilter="purchased"
        navigation={SEASON_CARD_NAVIGATION}
        tabParamKey="season_tab"
        tabParamValue="purchased"
        titleLabel={t("season_card", {
          ns: "taascard",
          defaultValue: "Season Card",
        })}
        emptyTitle={t("no_purchased_cards_title")}
        emptySubtitle={t("no_purchased_cards_subtitle")}
        showTalentFilter
        enabled={Boolean(userInfo?.id)}
        onExpandShare={onExpandShare}
        deckCardShareKind="season"
        mapFetchedMainCard={mapSeasonMainCardResponseToPublishedCard}
        secondaryUrlParam={{
          key: "seasonCardId",
          getValue: (card) => getSeasonCardIdFromCard(card),
        }}
      />
      {shareModal}
    </>
  );
};

export default SeasonCardUserPage;
